<template>
  <div
    class="modal-content"
    :class="{'modal-full-width': modalFullWidth}"
    v-if="isOpen"
  >
    <div class="modal-header">
      <div class="modal-title">
        <slot name="title" />
      </div>
      <button
        class="btn btn-borderless-primary btn-icon-close"
        @click="closeModal"
      >
        <i class="fas fa-times" />
      </button>
    </div>
    <div
      class="modal-body"
      :class="{'center': isCenter}"
    >
      <slot name="body" />
    </div>
    <div class="modal-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isCenter: {
      type: Boolean,
      default: false
    },
    modalFullWidth: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:isOpen', false)
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@abeja-inc/abeja-ui-library/scss/_variables.scss";

$modal-width: 50vw;

.modal-content {
  position: fixed;
  width: $modal-width;
  min-width: 450px;
  max-width: 670px;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  z-index: 501;
  overflow: auto;
  overflow-y: auto;

  .modal-title {
    font-size: $font-size-lg-2;
    font-weight: $font-weight-bold;
  }

  &.modal-full-width {
    width: 90vw;
    max-width: 1260px;
  }

  .modal-body {
    max-height: 60vh;
    overflow: scroll;
    &.center {
      text-align: center;
    }
  }
}

</style>
